import React, { useRef, useEffect, useCallback, useState} from 'react';
import Documented from 'components/help/Documented.js';
import DeletableEffectComponent from 'components/effects/DeletableEffectComponent.js';
import {getEffect} from './getEffect.js';
import {connect} from 'react-redux';
import {useScroll} from './useScroll.js';

const EffectComponent = (props) => { 
    let effectRef = useRef(undefined);
    let inner = (
          <DeletableEffectComponent
            {... props}
            onDeleteEffect={props.onDeleteEffect}
            effectNumber={props.effectNumber}
            onToggle={() => []}
            track={props.track}
            group={props.group}
            showDelete={props.showDelete}
            send={props.send}
            effect={props.effect}
            automation={props.automation}>
            {getEffect(props)}
          </DeletableEffectComponent>);
    return (
        <div ref={effectRef}>
          <Documented element={props.effect}>
            {inner}
          </Documented>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      linkedParameterSelected: state.effects.accumulatorParameterSelected,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EffectComponent);
